import { FontAwesomeIcon } from '@/components/Common/FontAwesomeIcon/FontAwesomeIcon';
import { useTranslate } from '@/hooks/useTranslate';
import { cn } from '@/utils/cn';

export const ItemsDetails = ({
  showPurchedItems,
  handleShowPurchedItems,
}: {
  showPurchedItems: boolean;
  handleShowPurchedItems: () => void;
}) => {
  const { t } = useTranslate();
  return (
    <div
      data-testid="items-details-toggle"
      data-state={showPurchedItems ? 'expanded' : 'collapsed'}
      className="flex items-center gap-2 cursor-pointer shrink-0"
      onClick={handleShowPurchedItems}
    >
      <FontAwesomeIcon icon="fa-regular fa-cart-shopping" className="!text-base" />
      <div className="font-semibold text-xs">{t('details')}</div>
      <FontAwesomeIcon
        icon="fa-regular fa-chevron-down"
        className={cn(`transition-transform duration-300 ease-in-out ${showPurchedItems ? 'rotate-180' : 'rotate-0'} `)}
      />
    </div>
  );
};
